<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container>
    <h1 class="titulo mb-3">MINHAS VENDAS</h1>

    <ExpansionPanel :value="activeItens" @mudarValores="setActiveItens">
      <v-expansion-panel :readonly="fixedItens.includes('status_do_contrato')"
        :style="{ 'order': fixedItens.includes('status_do_contrato') ? fixedItens.indexOf('status_do_contrato') : '99', 'margin': fixedItens.includes('status_do_contrato') || activeItens.includes(tabs.status_do_contrato) ? '20px 0px 20px 0px' : '1px 0px 0px 0px', 'border-radius': '0 !important' }">
        <ExpansionPanelHeader>Status do Contrato</ExpansionPanelHeader>
        <ExpansionPanelContentFixable :tab="'status_do_contrato'" @toggleFixed="toggleFixed('status_do_contrato')"
          :fixed="fixedItens.includes('status_do_contrato')">
          <template>
            <v-row v-show="carregandoDadosStatusContrato">
              <v-col v-for="(dado, index) in legenda" :key="index" cols="6" sm="6" lg="2" md="2" xl="1"
                class="col-xlg-1" style="min-width: 150px;">
                <v-skeleton-loader max-height="100" type="card-avatar"></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-item-group v-if="!carregandoDadosStatusContrato" multiple v-model="statusDoContratoSelecionados">
              <v-container>
                <v-row>
                  <v-col :key="-1" cols="6" sm="6" lg="1" md="2" xl="1" class="col-xlg-1 mt-2"
                    style="min-width: 150px;">
                    <v-item v-slot="{ active, toggle }" v-model="todos_os_status_ativo">
                      <v-card :color="cardContratoTodosSelecionado ? 'primary' : ''"
                        class="d-flex flex-column pa-2 align-center mt-1 mb-1 item-list__border" height="100"
                        weight="fit-content" @click="toggle">
                        <div class="text-h2 text-center item-list__card-number"
                          :style="{ 'color': cardContratoTodosSelecionado ? 'aliceblue' : 'var(--primary)' }">
                          {{ total_contratos }}
                        </div>
                        <div class="text-h2  text-center item-list__card-percentage"
                          :style="{ 'color': cardContratoTodosSelecionado ? 'aliceblue' : 'var(--primary)' }">
                          (100%)
                        </div>
                        <div class="text-h2 mt-1 text-center item-list__card-description"
                          :style="{ 'color': cardContratoTodosSelecionado ? 'aliceblue' : '' }">
                          Total
                        </div>
                      </v-card>
                    </v-item>
                  </v-col>
                  <v-col v-for="(dado, index) in legenda" :key="index" cols="6" sm="6" lg="1" md="2" xl="1"
                    class="col-xlg-1 mt-2" style="min-width: 150px;">
                    <v-item v-slot="{ active, toggle }">
                      <v-card
                        :style="{ 'border-color': active ? 'var(--primary) !important' : '', 'border': active ? '2px solid var(--primary) !important' : '  ' }"
                        class="d-flex flex-column pa-2 align-center mt-1 mb-1 item-list__border" height="100"
                        weight="fit-content" @click="toggle()">
                        <div class="text-h2 text-center item-list__card-number">
                          {{ dados[index] > 0 ? dados[index] : 0 }}
                        </div>
                        <div class="text-h2  text-center item-list__card-percentage">
                          ({{
                            dados[index] > 0 ?
                              parseInt((dados[index] * 100) / total_contratos) + '%' : 0 + '%'
                          }})
                        </div>
                        <div class="text-h2 mt-1 text-center item-list__card-description"
                          :style="{ 'color': active ? 'var(--primary)' : '' }">
                          {{ dado }}
                        </div>
                      </v-card>
                    </v-item>
                  </v-col>
                </v-row>
              </v-container>
            </v-item-group>
          </template>
        </ExpansionPanelContentFixable>
      </v-expansion-panel>
      <v-expansion-panel :readonly="fixedItens.includes('filtros_adicionais')" :style="{
        'order': fixedItens.includes('filtros_adicionais') ? fixedItens.indexOf('filtros_adicionais') : '99', 'margin': fixedItens.includes('filtros_adicionais') || activeItens.includes(tabs.filtros_adicionais) ?
          '20px 0px 20px 0px' : '1px 0px 0px 0px', 'border-radius': '0 !important'
      }">
        <ExpansionPanelHeader>
          Filtros Adicionais
          <template v-slot:actions>
            <v-icon color="primary">
              mdi-menu-down
            </v-icon>
          </template>
        </ExpansionPanelHeader>
        <ExpansionPanelContentFixable :tab="'filtros_adicionais'" @toggleFixed="toggleFixed('filtros_adicionais')"
          :fixed="fixedItens.includes('filtros_adicionais')">
          <m-form ref="filter" class="mt-4 ml-2">
            <v-row class="mb-8">
              <v-col cols="12" sm="6" md="3">
                <m-text-field id="FieldFiltroCpfCnpj" label="CPF/CNPJ do cliente: " outlined
                  hint="Não é necessário colocar pontos e traços!" :rules="[$rules.cpf_cnpj]" v-mask="cpfCnpjMask"
                  v-model="filters.cpfcnpjcliente" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <m-text-field outlined id="FieldNome" label="Nome / Razão social do cliente: "
                  v-model="filters.nome_cliente" v-uppercase />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <m-text-field id="FieldNomeDoBem" label="Nome do bem: " outlined v-model="filters.nome_bem"
                  v-uppercase />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <m-text-field id="FieldNumeroContrato" label="Número do contrato: " outlined
                  v-model="filters.id_documento" v-uppercase />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <DateField ref="data_inicial" id="FieldDataInicial" label="Data inicial da venda: "
                  v-model="filters.data_inicial" :rules="[validaDataInicial, $rules.date, $rules.dataPassada]"
                  max="today" @input="validaDatas" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <DateField ref="data_final" id="FieldDataFinal" label="Data final da venda: "
                  v-model="filters.data_final" :rules="[validaDataFinal, $rules.date, $rules.dataPassada]" max="today"
                  @input="validaDatas" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select id="FieldTipoGrupo" label="Tipo do grupo: " outlined v-model="filters.tipo_grupo"
                  menu-props="offsetY" hide-details placeholder="Selecione o tipo do grupo" :items="tipos_grupos"
                  item-text="name" item-value="value" />
              </v-col>
              <v-col cols="12" sm="6" md="4" class="mb-4" v-if="showComissionados">
                <v-select class="select_unidade" menu-props="offsetY" validate-on-blur outlined
                  id="FieldCodigoComissionado" label="Código/Nome do comissionado: " hide-details
                  v-model="filters.comissionado" placeholder="Selecione o comissionado" :items="comissionados"
                  item-text="NM_Pessoa" item-value="ID_Comissionado" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <m-text-field v-show="permite_multiplicar_cota" outlined id="FieldQuantidadeCotas"
                  v-input-filter="[$filters.numeric]" label="Quantidade de cotas: " v-model="filters.quantidade_cotas"
                  v-uppercase />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select id="FieldProcessoVenda" label="Processo da Venda: " outlined v-model="filters.processo_venda"
                  menu-props="offsetY" hide-details placeholder="Selecione o processo da venda"
                  :items="opcoesProcessoVenda" clearable item-text="name" item-value="value" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select id="FieldProcessoAnaliseCredito" label="Processo de Análise Cadastral: " outlined
                  v-model="filters.processo_analise_credito" menu-props="offsetY" hide-details
                  placeholder="Selecione o processo de análise" :items="opcoesProcessoAnaliseCredito" clearable
                  item-text="name" item-value="value" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select id="FieldProcessoPagamento" label="Processo de Pagamento: " outlined
                  v-model="filters.processo_pagamento" menu-props="offsetY" hide-details
                  placeholder="Selecione o processo de pagamento" :items="opcoesProcessoPagamento" clearable
                  item-text="name" item-value="value" />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-select id="FieldProcessoContrato" label="Processo do Contrato: " outlined
                  v-model="filters.processo_contrato" menu-props="offsetY" hide-details
                  placeholder="Selecione o processo do contrato" :items="opcoesProcessoContrato" clearable
                  item-text="name" item-value="value" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" sm="3" md="2" offset-sm="6" offset-md="8" class="mb-2 mt-2">
                <v-btn color="secondary" block @click="limpar" id="limpar">
                  Limpar
                </v-btn>
              </v-col>
              <v-col cols="6" sm="3" md="2" class="mb-2 mt-2">
                <v-btn color="primary" block @click="filtrar" id="filtrar">
                  Filtrar
                </v-btn>
              </v-col>
            </v-row>
          </m-form>
        </ExpansionPanelContentFixable>
      </v-expansion-panel>
      <v-expansion-panel :readonly="fixedItens.includes('marca_e_administradora')"
        :style="{ 'order': fixedItens.includes('marca_e_administradora') ? fixedItens.indexOf('marca_e_administradora') : '99', 'margin': fixedItens.includes('marca_e_administradora') || activeItens.includes(tabs.marca_e_administradora) ? '20px 0px 20px 0px' : '1px 0px 0px 0px', 'border-radius': '0 !important' }">
        <ExpansionPanelHeader>Marca e Administradora</ExpansionPanelHeader>
        <ExpansionPanelContentFixable :tab="'marca_e_administradora'"
          @toggleFixed="toggleFixed('marca_e_administradora')" :fixed="fixedItens.includes('marca_e_administradora')">
          <!-- Marca e Administradora -->

          <v-row v-show="(!carregouConfiguracaoMarcaEAdmin && carregouConfiguracaoMarcaEAdmin != null)">
            <v-col v-for="(dado, index) in quantidadeConfiguracaoMarcaEAdmin" :key="index" cols="6" sm="4" xl="2" md="3"
              class="mb-2 mt-2 mx-1 max-width">
              <v-skeleton-loader max-height="130" type="card-avatar"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-item-group multiple v-model="marcasEAdministradorasSelecionadas">
            <v-container>
              <v-row
                v-if="(carregouConfiguracaoMarcaEAdmin && carregouConfiguracaoMarcaEAdmin != null && possuiMarcasEAdministradoras)">
                <v-col v-for="(marcaEAdministradora, index) in marcasEAdministradoras" :key="index" cols="6" sm="4"
                  xl="2" md="3" class="mb-2 mt-2">
                  <v-item :value="marcaEAdministradora.id" v-slot="{ active, toggle }">
                    <v-card
                      :style="{ 'border-color': active ? 'var(--primary) !important' : '', 'border': active ? '2px solid var(--primary) !important' : '  ' }"
                      @click="toggle" class="mx-auto" min-height="100%">
                      <div class="d-flex align-center" style="flex-direction:column;">
                        <v-img class="logo mt-1 margin__break_point_sm" contain max-width='70%' max-height='90%'
                          height="110px" width="100%" style="background-size: contain;"
                          :src='"../assets/flavors/" + trazerNomeFlavor(marcaEAdministradora.nm_flavor) + "/img/logo-menu.png"'></v-img>
                      </div>
                      <div class="text-center display-flex flex-align-center pb-4"
                        :style="{ 'color': active ? 'var(--primary)' : 'grey', 'font-size': '15px', 'font-weight': 'bold', 'margin-bottom': active ? '0px' : 'inherit' }">
                        {{
                          trazerAdministradoraPorEmpresa(marcaEAdministradora.id_empresa_newcon)
                        }}
                      </div>
                    </v-card>
                  </v-item>
                </v-col>
                <v-item :value="outrosItem.id" v-slot="{ active, toggle }">
                  <v-col v-if="cardOutrosMarcaEAdministradoraAtivo" cols="6" sm="4" xl="2" md="3" class="mb-2 mt-2">
                    <!-- Card outros --->
                    <v-card @click="toggle"
                      :style="{ 'border-color': active ? 'var(--primary) !important' : '', 'border': active ? '2px solid var(--primary) !important' : '  ' }"
                      class="mx-auto" min-height="100%">
                      <div class="d-flex align-center" style="flex-direction:column;">
                        <v-icon class="logo " style="font-size:70px;margin: 17px;height:87px;background-size: contain;">
                          mdi-chart-donut
                        </v-icon>
                      </div>
                      <div class="text-center display-flex flex-align-center"
                        :style="{ 'color': active ? 'var(--primary)' : 'grey', 'font-size': '15px', 'font-weight': 'bold', 'margin-bottom': active ? '0px' : 'inherit' }">
                        Outros
                      </div>
                    </v-card>
                  </v-col>
                </v-item>
              </v-row>

              <v-row v-else-if="carregouConfiguracaoMarcaEAdmin === undefined || id_comissionado == null">
                <v-col cols="12" class="mb-2 mt-2">
                  Carregando comissionados...
                </v-col>
              </v-row>
              <v-row v-else-if="carregouConfiguracaoMarcaEAdmin && !possuiMarcasEAdministradoras">
                <v-col cols="12" class="mb-2 mt-2">
                  Não há dados disponíveis
                </v-col>
              </v-row>
              <v-row v-else-if="carregouConfiguracaoMarcaEAdmin === null">
                <v-col cols="12" class="mb-2 mt-2">
                  Falha ao carregar o filtro, atualize a página para tentar novamente. Se o erro
                  persistir, entre
                  em
                  contato com o administrador do sistema.
                </v-col>
              </v-row>
            </v-container>
          </v-item-group>

          <template>
          </template>
        </ExpansionPanelContentFixable>
      </v-expansion-panel>
    </ExpansionPanel>

    <v-card class="card mt-6">
      <v-card-text>
        <v-layout class="mb-3 d-flex justify-center">
          <template>
            <v-card flat class="pt-0">
              <v-card-text>
                <v-row align="center" justify="center">
                  <v-col cols="12">
                  </v-col>
                  <v-btn-toggle class="d-flex flex-wrap" v-model="toggle_exclusive" mandatory>
                    <v-btn v-for="(aba, key) in abasDosFiltros" :key="aba.index" @click="alterarAbas(key)"
                      :color="toggle_exclusive === aba.index ? 'primary' : ''"
                      :style="{ 'color': toggle_exclusive === aba.index ? 'aliceblue' : '' }" class="v-btn--round">
                      {{ aba.text.toUpperCase() }}
                    </v-btn>
                  </v-btn-toggle>
                </v-row>
              </v-card-text>
            </v-card>
          </template>
        </v-layout>
      </v-card-text>
      <DataTable ref="datatable" :disable-select="true" url="/vendas/listar" :params="params"
        @onLoad="handleDatatableLoad" class="vendas" :overflow-y-visible="true" @pagination="setPagination"
        :filter="dtFiltro">
        <template v-slot:items="{ item }">
          <div :ref="'card-' + item.id_pedido" class="mb-5 d-flex justify-center" style="max-width:100%;">
            <CardVenda :item="item" :id="item.id_pedido" @editar="editarMinhasVendas"
              :flavors-e-empresas-prop="flavorsEEmpresas" :flavors-prop="flavors" :administradoras="administradoras"
              :filtro-processo-venda="dtFiltro.processo_venda"
              :filtro-processo-analise-credito="dtFiltro.processo_analise_credito"
              :filtro-processo-pagamento="dtFiltro.processo_pagamento"
              :filtro-processo-contrato="dtFiltro.processo_contrato" />
          </div>
        </template>
      </DataTable>
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import { sendAnalyticsEvent } from '@/plugins/googleAnalytics'
import ExpansionPanel from '@/components/ExpansionPanel.vue'
import ExpansionPanelHeader from '@/components/ExpansionPanelHeader.vue'
import ExpansionPanelContentFixable from '@/components/ExpansionPanelContentFixable.vue'

import { merge } from 'lodash'
import { StatusContrato, StatusPedido as Status, StatusPedidoDesc as Desc, TiposGrupo, abasDosFiltros } from '@/plugins/constants'
import { OpcoesProcessoVenda, OpcoesProcessoAnaliseCredito, OpcoesProcessoPagamento, OpcoesProcessoContrato } from '@/plugins/processosDeVenda'
import startSellToCommercialHierarchy from '../mixins/CommercialHierarchy/startSellToCommercialHierarchy'
import { alert, asyncAlert, isVendaNaoGerada, notification } from '@/plugins/helpers'
import http from '@/plugins/http'
import editarVendasMixin from '@/mixins/editarVendasMixin'
import listarVendas from '@/mixins/listarVendas'
import CardVenda from '../components/minhas-vendas/CardVenda.vue'
import session from '@/plugins/session'
import { AlertTypes } from '@/plugins/alerts_types'
import PollingService from '@/helpers/polling'
import { verificarAtualizacoesPropostas } from '@/webservice/propostas'

export async function permiteEditar (pedido) {
  const brokerFluxo = session.get('broker_fluxo_vendas_comum')

  if (brokerFluxo === true) {
    return pedido
  }

  try {
    if (isVendaNaoGerada(pedido.status_pedido)) {
      const res = await http.get(`/compra/planodisponivel/${pedido.id_pedido}`)
      if (!res.data['disponivel']) {
        pedido = await asyncAlert('As condições anteriormente selecionadas de prazo, parcela e grupo não estão mais disponíveis.').then(() => removerCondicoesContratadas(pedido))
      }
    }
    return pedido
  } catch (error) {
    if (error?.response?.data?.Msg_Erro) {
      throw new Error(error.response.data.Msg_Erro)
    }
    throw error
  }
}

export async function removerCondicoesContratadas (pedido) {
  pedido = { ...pedido, id_reserva: null, bem: null, id_bem: null }
  delete pedido.produto
  const res = await http.post('/vendas', pedido)
  delete pedido.id_reserva
  delete pedido.bem
  delete pedido.id_bem
  return merge(pedido, res.data)
}

/**
 * @var item
 * @type {object}
 * @property {string} pagamento_enviado
 * @property {string} mensagem_venda
 */
export default {
  name: 'Relatorios',
  components: { ExpansionPanel, ExpansionPanelHeader, ExpansionPanelContentFixable, CardVenda },
  mixins: [editarVendasMixin, listarVendas, startSellToCommercialHierarchy],
  data: () => ({
    outrosItem: {
      id: 0,
      id_empresa_newcon: 0,
      id_flavor: 0,
      id_visual: 'Outros',
      id_visual_padrao_para_empresas: 0,
      nm_flavor: 'outros',
      unidades_negocio_exclusivas: 0
    },
    administradoras: [],
    carregandoDadosStatusContrato: false,
    permite_cnpj_alfanumerico: false,
    statusDoContratoSelecionados: [],
    cardContratoTodosSelecionado: true,
    marcasEAdministradorasSelecionadas: [],
    activeItens: [],
    quantidadeConfiguracaoMarcaEAdmin: 0,
    carregouConfiguracaoMarcaEAdmin: false,
    cardOutrosMarcaEAdministradoraAtivo: false,
    marcasEAdministradoras: [],
    toggle_exclusive: 0,
    fixedItens: [],
    tabs: {
      status_do_contrato: 0,
      filtros_adicionais: 1,
      marca_e_administradora: 2
    },
    buttons_id: 0,
    filter_open: false,
    todos_os_status_ativo: true,
    dtFiltro: {},
    filters: {
      nome_cliente: '',
      nome_bem: '',
      id_documento: '',
      cpfcnpjcliente: '',
      status_pedido: '',
      comissionado: '',
      data_inicial: '',
      data_final: '',
      status_contrato: '',
      tipo_grupo: '',
      quantidade_cotas: '',
      flavor_venda: '',
      processo_venda: '',
      processo_analise_credito: '',
      processo_pagamento: '',
      processo_contrato: ''
    },

    nome_bem: '',
    status_pedido: [],
    activetab: 'Todas',
    codigo_comissionado: '',
    pagination: {
      page: 1,
      totalItems: 0,
      rowsPerPage: 12,
      items_grid: 12,
      sortBy: '',
      descending: false
    },
    paginacaoGuardada: {
      page: 1,
      totalItems: 0,
      rowsPerPage: 12,
      items_grid: 12,
      sortBy: '',
      descending: false
    },
    dados: [],
    legenda: [
      'Pendente',
      'Assinado',
      'Negado',
      'Falha',
      'Em Espera'
    ],
    total_contratos: 0,
    tipos_grupos: [TiposGrupo.GrupoPontual, TiposGrupo.GrupoConvencional, TiposGrupo.GrupoPraJa, 'Todos'],
    dados_grafico: [],
    exibe_reenvio_whatsapp: false,
    payloadParaCriptografar: {},
    show: false
  }),
  computed: {
    possuiMarcasEAdministradoras () {
      return this.marcasEAdministradoras.length > 0
    },
    statusDoContratoSelecionadosFormatados () {
      return this.cardContratoTodosSelecionado ? [] : this.statusDoContratoSelecionados.filter((selecionado) => {
        return this.dados_grafico[selecionado - 1]
      }).map((selecionado) => {
        return this.dados_grafico[selecionado - 1].status
      })
    },
    cpfCnpjMask () {
      if (this.permite_cnpj_alfanumerico) {
        return {
          mask: ['SSS.SSS.SSS-SS', 'SS.SSS.SSS/SSSS-SS'],
          tokens: {
            'S': {
              pattern: /[A-Za-z0-9]/,
              transform: (char) => char.toUpperCase()
            }
          }
        }
      }
       return ['###.###.###-##', '##.###.###/####-##']
    },
    marcasEAdministradorasSelecionadasFormatadas () {
      return [...this.marcasEAdministradoras, this.outrosItem].filter(marca => this.marcasEAdministradorasSelecionadas.includes(marca.id))
    },
    ...mapState(['permite_multiplicar_cota', 'id_comissionado', 'id_comissionado_venda', 'comissionados', 'modalidades', 'id_empresa', 'id_unidade_negocio', 'flavor', 'id_usuario_interno', 'token', 'loading']),
    ...mapGetters(['filial']),
    params () {
      return {
        ...this.getPayloadGenericoFiltrarVendas,
        id_empresa: this.id_empresa,
        status: this.filtroStatus,
        is_tribanco: this.$session.get('flavor') === 'tribanco',
        identificador_representante_tribanco: this.$session.get('identificador_representante_tribanco'),
        id_unidade_negocio: this.id_unidade_negocio,
        ids_marcas_e_administradoras_selecionadas: JSON.stringify(this.marcasEAdministradorasSelecionadasFormatadas),
        status_contrato_selecionados: JSON.stringify(this.statusDoContratoSelecionadosFormatados),
        pagination: this.pagination
      }
    },
    StatusPedido () {
      return Object.keys(Status).map(value => ({ value: Desc[Status[value]], name: Desc[Status[value]] }))
    },
    StatusContrato () {
      return Object.keys(StatusContrato).map(value => ({ value: StatusContrato[value], name: StatusContrato[value] }))
    },
    filtroStatus () {
      return this.abasDosFiltros[this.activetab]?.value ?? this.abasDosFiltros['Todas'].value
    },
    abasDosFiltros () {
      return abasDosFiltros
    },
    showComissionados () {
      return this.comissionados.length > 1 && this.id_comissionado_venda === this.id_comissionado
    },
    filtro () {
      return {
        'nome_cliente': this.filters.nome_cliente,
        'nome_bem': this.filters.nome_bem,
        'id_documento': this.filters.id_documento,
        'cpfcnpjcliente': this.filters.cpfcnpjcliente,
        'status_pedido': this.filters.status_pedido,
        'id_comissionado': this.filters.comissionado,
        'data_inicial': this.filters.data_inicial,
        'data_final': this.filters.data_final,
        'status_contrato': this.filters.status_contrato,
        'tipo_grupo': this.filters.tipo_grupo,
        'quantidade_cotas': this.filters.quantidade_cotas,
        'marca_e_administradora': this.filters.marcas_e_administradoras,
        'processo_venda': this.filters.processo_venda,
        'processo_analise_credito': this.filters.processo_analise_credito,
        'processo_pagamento': this.filters.processo_pagamento,
        'processo_contrato': this.filters.processo_contrato
      }
    },
    opcoesProcessoVenda () {
      return OpcoesProcessoVenda
    },
    opcoesProcessoAnaliseCredito () {
      return OpcoesProcessoAnaliseCredito
    },
    opcoesProcessoPagamento () {
      return OpcoesProcessoPagamento
    },
    opcoesProcessoContrato () {
      return OpcoesProcessoContrato
    }

  },
  watch: {
    statusDoContratoSelecionados (selecionados) {
      let selecionadosTransformado = []
      if (selecionados.includes(true)) {
        this.cardContratoTodosSelecionado = true
        this.statusDoContratoSelecionados = []
        return
      } else {
        this.cardContratoTodosSelecionado = false
      }
      if (selecionados.length === 0) {
        this.cardContratoTodosSelecionado = true
      }

      sendAnalyticsEvent(this.$gtag, 'minhas_vendas_statusContrato', {
        status: this.cardContratoTodosSelecionado ? 'Todos' : selecionadosTransformado.join(', ')
      })

      this.filtrarSemFormulario()
    },
    id_comissionado_venda () {
      this.getDadosStatusContrato()
      this.getPainelMarcaEAdministradora()
    },
    'hierarquia_comercial.gerenteNegocioSelecionado' () {
      this.getPainelMarcaEAdministradora()
      this.getFlavorsEEmpresas()
      this.getFlavors()
      this.getAdministradoras()
      this.getConfiguracaoPaineisMinhasVendas()
      this.getDadosStatusContrato()
    },
    marcasEAdministradorasSelecionadas () {
      this.filtrarSemFormulario()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!(to.name === 'troca_ambiente') || this.podeRedirecionarParaTrocaAmbiente) {
      next()
    } else {
      next(false)
      alert({
        text: `Você foi redirecionado para outra marca. \nPara retornar ao ambiente faça a troca novamente.`,
        buttons: {
          'Ok': () => true
        }
      })
    }
  },
  created () {
    const isTrocaAmbiente = this.$session.get('trocando_ambiente')
    if (isTrocaAmbiente && !this.is_usuario_logado_hierarquia) {
      this.resetarFlavorPorAmbiente()
    }

    if (this.$store?.state?.minhasVendas?.isFiltrosAnteriores) {
      const { filters, dtFiltro, pagination, selectedSaleId, statusDoContratoSelecionados, marcasEAdministradorasSelecionadas, toggle_exclusive, activetab } = this.$store.getters['minhasVendas/getFiltrosAnteriores']
      this.filters = { ...filters }
      this.dtFiltro = { ...dtFiltro }
      this.pagination = { ...pagination, keep_pagination: true }
      this.selectedSaleId = selectedSaleId
      this.statusDoContratoSelecionados = [...statusDoContratoSelecionados]
      this.marcasEAdministradorasSelecionadas = [...marcasEAdministradorasSelecionadas]
      this.toggle_exclusive = toggle_exclusive
      this.activetab = activetab || abasDosFiltros['Todas']
    }
    this.$store.commit('minhasVendas/SET_IS_FILTROS_ANTERIORES', false)
    this.permite_cnpj_alfanumerico = this.$session.get('permite_cnpj_alfanumerico')
  },
  async mounted () {
    if (this.is_usuario_logado_hierarquia) {
      this.resetarFlavor()
      this.$session.set('sinalMudarIdentidadeVisual', true)
      if (!this.$route.query.redirecionamentoPainelLateral) {
        this.resetarEstruturaComercial()
      }
      this.resetarUnidadeNegocio()
    }
    this.exibe_contratos = this.$session.get('exibe_contratos_sistema')
    this.exibe_reenvio_whatsapp = this.$session.get('exibe_reenvio_whatsapp')
    Promise.all([this.getPainelMarcaEAdministradora(), this.getFlavorsEEmpresas(), this.getFlavors(), this.getAdministradoras(), this.getConfiguracaoPaineisMinhasVendas(), this.getDadosStatusContrato()])
  },
  beforeDestroy () {
  },
  methods: {
    async handleDatatableLoad () {
      this.navegarParaVenda()
      await this.verificaExistenciaSimulacao()
    },
    navegarParaVenda () {
      this.$nextTick(() => {
        if (this.selectedSaleId) {
          const cardRef = `card-${this.selectedSaleId}`
          const cardElement = this.$refs[cardRef]
          if (cardElement) {
            cardElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
            this.selectedSaleId = null
          }
        }
      })
    },
    async verificaExistenciaSimulacao () {
      const cdSimulacao = this.$session.get('cd_simulacao')
      const isSimulacao = this.$session.get('simulacao')
      if (!cdSimulacao) return

      const pedidoSimulacao = this.encontrarPedidoPorSimulacao(cdSimulacao)

      if (pedidoSimulacao && isSimulacao) {
        this.validarSimulacao(pedidoSimulacao, isSimulacao)
      }
    },
    encontrarPedidoPorSimulacao (cdSimulacao) {
      // Busca nos dados já carregados pela DataTable
      const items = this.$refs.datatable?.items || []

      return items.find(item => item.cd_simulacao_ed === cdSimulacao)
    },

    async validarSimulacao (venda, isSimulacao) {
      try {
        const response = await this.$http.get(`/validar_condicoes_venda/${venda.id_pedido}`)

        if (response.data.success) {
          const { id_tipo_venda, grupos_originais } = response.data

          venda = {
            ...venda,
            id_tipo_venda,
            grupos_originais
          }
          this.editarMinhasVendas(venda, isSimulacao)
        }
      } catch (error) {
        this.$session.set('simulacao', false)
        this.$session.set('cd_simulacao', null)
        notification(AlertTypes.ERROR, `Caro parceiro, as condições pré-selecionadas no buscador de grupos não existem na Plataforma de vendas. Por favor, entre em contato com a Área de Suporte indicando o seguinte erro: ${error.response.data.erro}`)
      }
    },
    setPagination (newPagination) {
      this.paginacaoGuardada = newPagination
    },
    setActiveItens (itens) {
      this.activeItens = itens
    },
    editarMinhasVendas (venda, isSimulacao = false) {
      this.setarFiltrosMinhasVendas(venda.id_pedido)
      this.editar(venda, false, isSimulacao)
    },
    setarFiltrosMinhasVendas (id_pedido) {
      this.$store.dispatch('minhasVendas/saveFilters', {
        filters: this.filters,
        dtFiltro: this.dtFiltro,
        pagination: this.paginacaoGuardada,
        selectedSaleId: id_pedido,
        statusDoContratoSelecionados: this.statusDoContratoSelecionados,
        marcasEAdministradorasSelecionadas: this.marcasEAdministradorasSelecionadas,
        toggle_exclusive: this.toggle_exclusive,
        activetab: this.activetab
      })
    },
    async getPainelMarcaEAdministradora (painelSilent = true) {
      const payloadBase = this.getPayloadGenericoFiltrarVendas
      const id_comissionado = this.id_comissionado_venda
      if (id_comissionado == null) {
        this.carregouConfiguracaoMarcaEAdmin = undefined
        return
      }

      this.quantidadeConfiguracaoMarcaEAdmin = 3
      this.carregouConfiguracaoMarcaEAdmin = false

      return this.$http.post('/paineis/marca_e_administradora', { ...payloadBase }, { options: { silent: !!painelSilent } }
      ).then((result) => {
        this.cardOutrosMarcaEAdministradoraAtivo = result.data.possuiOutros
        this.marcasEAdministradoras = result.data.marcasEAdministradoras
        this.carregouConfiguracaoMarcaEAdmin = true
      }).catch(() => {
        this.carregouConfiguracaoMarcaEAdmin = null
      })
    },
    async getConfiguracaoPaineisMinhasVendas () {
      await this.$http.get(`/configuracao/paineis/minhas_vendas/${this.$session.get('id_usuario_interno')}`).then((result) => {
        this.fixedItens = result.data
      })
      this.fixedItens.forEach((element) => {
        this.activeItens.push(this.tabs[element])
      })
    },
    toggleFixed (item) {
      this.fixedItens.includes(item) ? this.fixedItens.splice(this.fixedItens.indexOf(item), 1) : this.fixedItens.unshift(item)
      this.$http.post('/configuracao/paineis/minhas_vendas', {
        'itens_fixados': this.fixedItens,
        'id_usuario': this.$session.get('id_usuario_interno')
      },
        {
          options: { silent: true }
        })
    },
    validaDatas () {
      this.$refs.data_inicial.validate()
      this.$refs.data_final.validate()
    },
    validaDataInicial () {
      const data_inicial = moment(this.filters.data_inicial)
      const data_final = moment(this.filters.data_final)
      if (data_final.isValid() && data_inicial.isAfter(data_final)) {
        return 'Data Inicial não pode ser maior que a Data Final!'
      }
      return true
    },
    validaDataFinal () {
      const data_inicial = moment(this.filters.data_inicial)
      const data_final = moment(this.filters.data_final)
      if (data_inicial.isValid() && data_final.isBefore(data_inicial)) {
        return 'Data Final não pode ser menor que a Data Inicial!'
      }
      return true
    },
    toggleFiltro () {
      this.filter_open = !this.filter_open
    },
    filtrar () {
      if (this.$refs.filter.validate()) {
        sendAnalyticsEvent(this.$gtag, 'minhas_vendas_filtroAdicional', {
          status: this.StatusPedido.find(status => status.value === this.filtro.status_pedido)?.name,
          tipo_grupo: this.filtro.tipo_grupo
        })
        this.dtFiltro = { ...this.filtro }
        this.getDadosStatusContrato()
      }
    },
    filtrarSemFormulario () {
      this.dtFiltro = { ...this.filtro }
    },
    alterarAbas (aba) {
      this.activetab = aba
      sendAnalyticsEvent(this.$gtag, 'minhas_vendas_visualização', { status: this.activetab })
      this.getDadosStatusContrato()
      this.filtrarSemFormulario()
    },
    limpar () {
      this.filters = {
        nome_cliente: '',
        nome_bem: '',
        id_documento: '',
        cpfcnpjcliente: '',
        status_pedido: '',
        comissionado: '',
        data_inicial: '',
        data_final: '',
        status_contrato: '',
        tipo_grupo: '',
        quantidade_cotas: '',
        processo_venda: '',
        processo_analise_credito: '',
        processo_pagamento: '',
        processo_contrato: ''
      }
      this.statusDoContratoSelecionados = []
      this.dtFiltro = {}
      this.getDadosStatusContrato()
    },
    async getDadosStatusContrato () {
      this.carregandoDadosStatusContrato = true
      this.dados = []
      const payloadBase = this.getPayloadGenericoFiltrarVendas
      const res = await this.$http.get('/vendas/dados_status_contrato', {
        params: {
          ...payloadBase,
          id_empresa: this.id_empresa,
          filter: this.filtro,
          status: this.filtroStatus,
          identificador_representante_tribanco: this.$session.get('identificador_representante_tribanco'),
          id_unidade_negocio: this.id_unidade_negocio,
          ids_marcas_e_administradoras_selecionadas: JSON.stringify(this.marcasEAdministradorasSelecionadasFormatadas),
          status_contrato_selecionados: JSON.stringify(this.statusDoContratoSelecionadosFormatados)
        }
      }).catch(() => {
        this.carregandoDadosStatusContrato = false
      })
      this.dados_grafico = res.data

      this.legenda.forEach((len) => {
        let retornou_legenda = false
        res.data.forEach((dado) => {
          if (dado.status === len) {
            retornou_legenda = true
          }
        })
        if (!retornou_legenda) {
          res.data.push({ value: 0, status: len })
        }
      })

      const valores = res.data.map(item => item.value)
      const legenda_retornada = res.data.map(item => item.status)

      this.dados = valores
      this.legenda.forEach((len) => {
        if (!legenda_retornada.includes(len)) {
          legenda_retornada.push(len)
        }
      })

      this.legenda = legenda_retornada
      this.total_contratos = this.dados.reduce(function (total, numero) {
        return total + numero
      }, 0)
      this.carregandoDadosStatusContrato = false
      return this.dados
    },
    /**
     * Inicia polling automático de propostas/contratos (FRONT-6)
     *
     * Cria instância do PollingService para verificar atualizações
     * a cada 30 segundos. Pausa quando página está oculta.
     */
    iniciarPollingPropostas () {
      // Só inicia se tiver ID do comissionado
      if (!this.id_comissionado_venda) {
        if (process.env.NODE_ENV === 'development') {
          console.warn('[MinhasVendas] Polling não iniciado: id_comissionado_venda não disponível')
        }
        return
      }

      this.pollingPropostas = new PollingService(
        async () => {
          await this.verificarAtualizacoesPropostas()
        },
        30000, // 30 segundos
        {
          debug: localStorage.getItem('DEBUG_POLLING') === 'true' || process.env.NODE_ENV === 'development',
          maxRetries: 3,
          retryDelay: 5000,
          onError: (error) => {
            if (process.env.NODE_ENV === 'development') {
              console.error('[MinhasVendas] Erro no polling de propostas:', error)
            }
          }
        }
      )

      this.pollingPropostas.start()

      // Cria handler com binding correto do 'this' para o event listener
      // Isso garante que o contexto do Vue seja preservado e que a mesma
      // referência seja usada tanto no add quanto no remove (evita memory leak)
      this._visibilityChangeHandlerPropostas = () => this.handleVisibilityChangePropostas()

      // Integração com Page Visibility API
      document.addEventListener('visibilitychange', this._visibilityChangeHandlerPropostas)

      if (process.env.NODE_ENV === 'development') {
        console.log('[MinhasVendas] Polling de propostas iniciado')
      }
    },
    /**
     * Verifica se houve atualizações em propostas/contratos (FRONT-6)
     *
     * Compara hash atual com hash armazenado para detectar mudanças.
     * Se houver mudanças, recarrega a lista de vendas.
     */
    async verificarAtualizacoesPropostas () {
      try {
        this.atualizandoPropostasAutomaticamente = true

        const resultado = await verificarAtualizacoesPropostas({
          id_comissionado: this.id_comissionado_venda,
          ultimo_hash: this.hashPropostas
        })

        // Atualiza o hash conhecido
        this.hashPropostas = resultado.data.hash_atual

        // ✨ MELHORIA #4: Se há atualizações, usar dados incluídos no response
        if (resultado.data.tem_atualizacao) {
          // Verificar se backend enviou dados completos
          if (resultado.data.propostas && resultado.data.propostas.length > 0) {
            // ✅ Usar dados do response (elimina segundo request)
            // Verificar se deve atualizar baseado no contexto
            const deveAtualizar = await this.verificarSeDeveRecarregarVendas()

            if (deveAtualizar) {
              // Atualizar dados locais com as propostas do response
              // Nota: Adaptar conforme estrutura de dados do componente
              this.aplicarAtualizacoesPropostas(resultado.data.propostas)

              // Exibir notificação discreta
              notification(
                AlertTypes.INFO,
                'Suas vendas foram atualizadas'
              )
            }
          } else {
            // Fallback: recarregar tudo se não vieram dados
            const deveRecarregar = await this.verificarSeDeveRecarregarVendas()

            if (deveRecarregar) {
              await this.buscar()

              notification(
                AlertTypes.INFO,
                'Suas vendas foram atualizadas'
              )
            }
          }
        }
      } catch (error) {
        // Erros são tratados pelo PollingService (retry automático)
        if (process.env.NODE_ENV === 'development') {
          console.error('[MinhasVendas] Erro ao verificar atualizações:', error)
        }
        throw error
      } finally {
        this.atualizandoPropostasAutomaticamente = false
      }
    },
    /**
     * Verifica se deve recarregar vendas baseado no contexto atual
     *
     * Evita recarregar se usuário está editando algo ou em um modal.
     *
     * @returns {Promise<boolean>} Se deve recarregar
     */
    async verificarSeDeveRecarregarVendas () {
      // Não recarregar se há diálogos abertos
      const dialogosAbertos = document.querySelectorAll('.v-dialog--active')
      if (dialogosAbertos && dialogosAbertos.length > 0) {
        if (process.env.NODE_ENV === 'development') {
          console.log('[MinhasVendas] Não recarregando: há diálogos abertos')
        }
        return false
      }

      // Pode adicionar outras verificações aqui
      // Por exemplo: se usuário está editando um campo específico

      return true
    },
    /**
     * Aplica atualizações de propostas recebidas do backend (MELHORIA #4)
     *
     * Atualiza os dados locais com as propostas modificadas,
     * evitando necessidade de recarregar toda a lista.
     *
     * @param {Array} propostasAtualizadas - Propostas com dados atualizados
     */
    aplicarAtualizacoesPropostas (propostasAtualizadas) {
      // Por simplicidade, recarregar completo
      // Em implementação futura, pode-se fazer merge inteligente
      // dos dados atualizados com os dados locais

      if (process.env.NODE_ENV === 'development') {
        console.log('[MinhasVendas] Aplicando atualizações:', propostasAtualizadas.length, 'propostas')
      }

      // Por enquanto, trigger reload completo
      // Melhoria futura: fazer merge seletivo
      this.buscar()
    },
    /**
     * Para o polling de propostas e limpa recursos (FRONT-6)
     */
    pararPollingPropostas () {
      if (this.pollingPropostas) {
        this.pollingPropostas.destroy()
        this.pollingPropostas = null
      }

      // Remover listener de visibilidade usando a mesma referência
      if (this._visibilityChangeHandlerPropostas) {
        document.removeEventListener('visibilitychange', this._visibilityChangeHandlerPropostas)
      }

      this.hashPropostas = null
      this.atualizandoPropostasAutomaticamente = false

      if (process.env.NODE_ENV === 'development') {
        console.log('[MinhasVendas] Polling de propostas parado')
      }
    },
    /**
     * Gerencia polling baseado na visibilidade da página (FRONT-6)
     */
    handleVisibilityChangePropostas () {
      if (!this.pollingPropostas) return

      if (document.hidden) {
        // Página oculta - pausar polling
        this.pollingPropostas.pause()
        if (process.env.NODE_ENV === 'development') {
          console.log('[MinhasVendas] Página oculta - pausando polling de propostas')
        }
      } else {
        // Página visível - retomar polling com verificação imediata
        this.pollingPropostas.resume(true)
        if (process.env.NODE_ENV === 'development') {
          console.log('[MinhasVendas] Página visível - retomando polling de propostas')
        }
      }
    }
  }

}

</script>

<style lang="scss" scoped>
.icon {
  font-size: 2rem;
}
</style>
